import classNames from './WafBlockedContent.module.scss';
import SVG from 'react-inlinesvg';
import TheButton from '@/components/TheButton/TheButton';
import { useNavigate } from 'react-router-dom';

import shieldLock from '@/assets/svg/waf-blocked.svg';

interface WafBlockedContentProps {
  error: string;
  title: string;
  description: string;
  buttonText: string;
}

const WafBlockedContent = ({ error, title, description, buttonText }: WafBlockedContentProps) => {
  const navigate = useNavigate();

  return (
    <div className={classNames.wafBlockedContent}>
      <SVG src={shieldLock} />
      <span className={classNames.error}>{error}</span>
      <h2>{title}</h2>
      <p>{description}</p>
      <TheButton
        className={classNames.btn}
        text={buttonText}
        shouldRecolor={false}
        emitOnClick={() => navigate('/login')}
      />
    </div>
  );
};

export default WafBlockedContent;
